import React, { FC, useState } from "react";
import "./ToggleSwitch.scss";
import { FormControlLabel, Switch } from "@mui/material";

type ToggleSwitchProps = {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id: string;
  onLabel?: string;
  offLabel?: string;
  className?: string;
  label?: string;
  labelClass?: string;
  color?: any;
};

const ToggleSwitch: FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  id,
  onLabel,
  offLabel,
  className,
  label,
  labelClass,
  color = "success"
}: ToggleSwitchProps) => {
  return !onLabel ? (
    <FormControlLabel
      className={`toggle_switch__label ${labelClass}`}
      label={label}
      control={
        <Switch
          checked={checked}
          onChange={onChange}
          id={id}
          className={className}
          color={color}
        />
      }
    />
  ) : (
    <div className="switch-content">
      <p>{label}</p>
      <p className="switch-label">{offLabel}</p>
      <Switch
        checked={checked}
        onChange={onChange}
        id={id}
        className={className}
        color={color}
      />
      <p>{onLabel}</p>
    </div>
  );
};

export default ToggleSwitch;
